import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.2261 5.78358C11.4653 6.0324 11.4622 6.42885 11.2168 6.67385L6.14233 11.7049H2.98546C2.81446 11.7151 2.58976 11.4746 2.5806 11.3098L2.54541 8.17503L7.61704 3.07394C7.86554 2.82576 8.26848 2.82576 8.51698 3.07394L8.52634 3.08349L8.87646 2.73349C9.12503 2.48467 9.52791 2.48467 9.77647 2.73349L11.5764 4.53312C11.8249 4.78194 11.8249 5.18476 11.5764 5.43358L11.2261 5.78358ZM4.01719 8.47412L5.81708 10.2738L9.8669 6.22394L8.06701 4.42431L4.01719 8.47412Z",
  fill: "#FEFEFE"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("mask", {
  id: "mask0_2345_69873",
  style: {"mask-type":"luminance"},
  maskUnits: "userSpaceOnUse",
  x: "2",
  y: "2",
  width: "10",
  height: "10"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.2261 5.78358C11.4653 6.0324 11.4622 6.42885 11.2168 6.67385L6.14233 11.7049H2.98546C2.81446 11.7151 2.58976 11.4746 2.5806 11.3098L2.54541 8.17503L7.61704 3.07394C7.86554 2.82576 8.26848 2.82576 8.51698 3.07394L8.52634 3.08349L8.87646 2.73349C9.12503 2.48467 9.52791 2.48467 9.77647 2.73349L11.5764 4.53312C11.8249 4.78194 11.8249 5.18476 11.5764 5.43358L11.2261 5.78358ZM4.01719 8.47412L5.81708 10.2738L9.8669 6.22394L8.06701 4.42431L4.01719 8.47412Z",
    fill: "white"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("g", { mask: "url(#mask0_2345_69873)" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render };